import {ModalTextContainer} from './meeting-room-modal-msg.styles';

import {Typography} from '@innowise-group/ui-kit';

interface MeetingRoomModalMsgProps {
  text: string;
}

const MeetingRoomModalMsg = ({text}: MeetingRoomModalMsgProps) => {
  const sentences = text.split(/(?<=[!.])\s+/);

  return (
    <ModalTextContainer>
      {sentences.map((sentence, index) => (
        <Typography type="h3" key={index}>
          {sentence}
        </Typography>
      ))}
    </ModalTextContainer>
  );
};

export default MeetingRoomModalMsg;
